import React, { useContext, useRef } from 'react';
import styles from './styles/MobileNavbarMenu.module.css';
import AuthContext from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../services/AuthServices';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faRightFromBracket, faComment } from '@fortawesome/free-solid-svg-icons';

const MobileNavbarMenu = ({ setShowMenu, user }) => {
    const { getLoggedIn } = useContext(AuthContext);
    const navigate = useNavigate();
    const menuRef = useRef(null);

    const handleClickProfile = () => {
        if (user) {
            navigate(`/user/${user.username}`, { state: { fromNavbar: true } });
            setShowMenu(false);
        }
    };

    const handleClickLogout = async () => {
        try {
            await logout();
            await getLoggedIn();
            navigate("/logging-out");
            setShowMenu(false);
        } catch (error) {
            console.error('Error during logout:', error);
        }
    };

    const handleClickSiteFeedback = () => {
        navigate('/site-feedback-page');
        setShowMenu(false);
    };

    return (
        <div
            ref={menuRef}
            className={styles.mobileDropdown}
            onClick={(e) => e.stopPropagation()}
        >
            <div className={styles.menuItem} onClick={handleClickProfile}>
                <div className={styles.iconContainer}>
                    {user?.profilePicture ? (
                        <img
                            src={user.profilePicture}
                            alt="Profile"
                            className={styles.profilePicture}
                        />
                    ) : (
                        <FontAwesomeIcon icon={faUser} className={styles.icon} />
                    )}
                </div>
                <div className={styles.textContainer}>
                    <div className={styles.label}>Account</div>
                </div>
            </div>

            <div className={styles.menuItem} onClick={handleClickSiteFeedback}>
                <div className={styles.iconContainer}>
                    <FontAwesomeIcon icon={faComment} className={styles.icon} />
                </div>
                <div className={styles.textContainer}>
                    <div className={styles.label}>Site Feedback</div>
                </div>
            </div>

            <div className={styles.menuItem} onClick={handleClickLogout}>
                <div className={styles.iconContainer}>
                    <FontAwesomeIcon icon={faRightFromBracket} className={styles.icon} />
                </div>
                <div className={styles.textContainer}>
                    <div className={styles.label}>Logout</div>
                </div>
            </div>
        </div>
    );
};

export default MobileNavbarMenu;